import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { FormErrorsComponent } from '../../../shared/form-errors/form-errors.component';
import { ValidationService } from '../../../core/services/validation.service';
import { AuthService } from '../../../core/services/auth.service';
import { ToastMessageService } from '../../../core/services/toast-message.service';
import { StorageService } from '../../../core/services/storage.service';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../../core/services/session-storage.service copy';
import { NgClass } from '@angular/common';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-login',
  imports: [
    CardModule,
    CheckboxModule,
    ReactiveFormsModule,
    FormsModule,
    FormErrorsComponent,
    NgClass,
    ButtonModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {


  loginForm: FormGroup = new FormGroup({});
  loadingSubmit: boolean = false;
  showPassword: boolean = false;
  rememberMe: boolean = true;

  constructor(
    private validationService: ValidationService,
    private authService: AuthService,
    private toasterService: ToastMessageService,
    private storageService: StorageService,
    private sessionStorageService: SessionStorageService,
    private route: Router
  ) {

  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.pattern(this.validationService.emailRegex)]),
      password: new FormControl('', [Validators.required]),
    })
  }

  submit() {
    if (this.loginForm.valid) {
      this.loadingSubmit = true;
      this.authService.login(this.loginForm.value).subscribe({
        next: (resp: any) => {
          this.loadingSubmit = false;
          this.toasterService.toastOnSuccess('Success', "You logged in successfully");
          if (this.rememberMe) {
            this.storageService.setToken(resp?.token);
            this.storageService.setUserRole(resp?.role);
            this.storageService.setUserData(resp?.email);

          } else {
            this.sessionStorageService.setToken(resp?.token);
            this.sessionStorageService.setUserRole(resp?.role);
            this.sessionStorageService.setUserData(resp?.email);
          }
          this.route.navigate(['/dashboard']);
        }, error: error => {
          this.loadingSubmit = false;

        }
      })
    } else {
      this.loginForm.markAllAsTouched();
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

} 
